
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import "../Components/BookingPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../firebase-config";
import dayjs from "dayjs";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
} from "firebase/firestore";
import emailjs from "@emailjs/browser";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function BookingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    tripType,
    pickup,
    drop,
    date,
    time,
    hours,
  } = location.state || {};
  const [carsData, setCarsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cabType, setCabType] = useState([]);
  const [seatFilter, setSeatFilter] = useState([]);
  const [modelFilter, setModelFilter] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPopModal, setShowPopModal] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    title:"BOOKING CONFIRMATION - " + dayjs().format("DD/MM/YYYY hh:mm A")
  });

  useEffect(() => {
    const fetchCars = async () => {
      setLoading(true);

      try {
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Cars")
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setCarsData(data);
      } catch (error) {
        console.error("Error fetching cars:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, []);

  // ================= FILTER TOGGLE =================

  const toggleFilter = useCallback(
    (value, state, setState) => {
      if (state.includes(value)) {
        setState(state.filter((item) => item !== value));
      } else {
        setState([...state, value]);
      }
    },
    []
  );

  // ================= MEMOIZED DATA =================

  // FILTERED CARS
  const filteredCars = useMemo(() => {
    return carsData?.filter((car) => {
      return (
        (cabType.length === 0 ||
          cabType.includes(car.type)) &&
        (seatFilter.length === 0 ||
          seatFilter.includes(Number(car.seats))) &&
        (modelFilter.length === 0 ||
          modelFilter.includes(car.name))
      );
    });
  }, [carsData, cabType, seatFilter, modelFilter]);

  // UNIQUE TYPES
  const uniqueTypes = useMemo(() => {
    return [...new Set(carsData?.map((car) => car.type))];
  }, [carsData]);

  // UNIQUE SEATS
  const uniqueSeats = useMemo(() => {
    return [
      ...new Set(
        carsData?.map((car) => Number(car.seats))
      ),
    ];
  }, [carsData]);

  // UNIQUE MODELS
  const uniqueModels = useMemo(() => {
    return [...new Set(carsData?.map((car) => car.name))];
  }, [carsData]);

  // TYPE COUNTS
  const typeCounts = useMemo(() => {
    const counts = {};

    carsData?.forEach((car) => {
      counts[car.type] =
        (counts[car.type] || 0) + 1;
    });

    return counts;
  }, [carsData]);

  // SEAT COUNTS
  const seatCounts = useMemo(() => {
    const counts = {};

    carsData?.forEach((car) => {
      const seat = Number(car.seats);

      counts[seat] =
        (counts[seat] || 0) + 1;
    });

    return counts;
  }, [carsData]);

  // ================= BOOK CLICK =================

  const handleBookClick = useCallback((car) => {
    setSelectedCar(car);
    setShowModal(true);
  }, []);

  // ================= SUBMIT =================


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
   setLoading(true);
    const bookingData = {
      ...formData,

      carName: selectedCar.name,
      carType: selectedCar.type,
      carSeats: selectedCar.seats,
      carPrice: selectedCar.price,

      tripType,
      pickup,
      drop,

      date: dayjs(date?.$d || date).format("DD/MM/YYYY"),
      time: dayjs(time?.$d || time).format("hh:mm A"),

      hours: hours
        ? `${hours.hours} Hrs (${hours.km} km)`
        : "-",

      createdAt: new Date(),
    };

    // Save to Firestore
    await addDoc(collection(db, "bookings"), bookingData);

    // Email 1 - Owner
    await emailjs.send(
      "service_xig8v68", 
      "template_ojc30ge", // Your Owner Template ID
      { 
        title: bookingData.title,
        name: bookingData.name,
        email: bookingData.email,
        mobile: bookingData.mobile,

        pickup: bookingData.pickup,
        drop: bookingData.drop,

        date: bookingData.date,
        time: bookingData.time,

        carName: bookingData.carName,
        carType: bookingData.carType,
         carSeats: bookingData.carSeats,

        tripType: bookingData.tripType,
        hours: bookingData.hours,
      },
      "J5IWtWloMsWA221Wk"
    );

    // Email 2 - Customer Auto Reply
    await emailjs.send(
      "service_xig8v68",
      "template_5mgc48f", // Your Customer Template ID
      {
        name: bookingData.name,
        email: bookingData.email,
        pickup: bookingData.pickup,
        drop: bookingData.drop,
        carName: bookingData.carName,
        date: bookingData.date,
        time: bookingData.time,
        hours: bookingData.hours,
        tripType: bookingData.tripType,
      },
      "J5IWtWloMsWA221Wk" 
    );

    toast.success(
      "Booking submitted successfully! A confirmation email has been sent."
    );

    setShowModal(false);
    setShowPopModal(true);

    setFormData({
      name: "",
      email: "",
      mobile: "",
    });

      // Navigate after 5 seconds
  setTimeout(() => {
    setShowPopModal(false);
    navigate("/home");
  }, 5000);
  } catch (error) {
    console.error("Booking Error:", error);

    toast.error(
      error?.text ||
      error?.message ||
      "Failed to submit booking"
    );
  }
  finally {
      setLoading(false);
    }

};
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     await addDoc(collection(db, "bookings"), {
  //       ...formData,
  //       carName: selectedCar.name,
  //       carType: selectedCar.type,
  //       carSeats: selectedCar.seats,
  //       carPrice: selectedCar.price,
  //       carImage: selectedCar.image,

  //       tripType,
  //       pickup,
  //       drop,

  //       date: dayjs(date.$d || date).format("DD/MM/YYYY"),

  //       time: dayjs(time.$d || time).format("hh:mm A"),
  //       hours: hours
  //         ? `${hours.hours} Hrs (${hours.km} km)`
  //         : "-",

  //       pickupCoords,
  //       dropCoords,

  //       createdAt: new Date(),
  //     });

  //     toast.success("Booking Submitted Successfully!"); 

  //     setShowModal(false);

  //     setFormData({
  //       name: "",
  //       email: "",
  //       mobile: "",
  //     });

  //     navigate("/home");

  //   } catch (error) {
  //     toast.error(
  //       "Booking Error:",
  //       error
  //     );
  //   }
  // };


  return (
    <div className="bookingContainer">
<ToastContainer position="top-right" autoClose={2000} />
      {/* ================= FILTER SECTION ================= */}

      <div className="filters">

        <h3>Select Filters</h3>

        {/* CAB TYPE */}

        <h4>Cab Type</h4>

        {uniqueTypes?.map((type) => (
          <label key={type}>

            <input
              type="checkbox"
              checked={cabType.includes(type)}
              onChange={() =>
                toggleFilter(
                  type,
                  cabType,
                  setCabType
                )
              }
            />

            {type} ({typeCounts[type] || 0})

          </label>
        ))}

        {/* SEAT FILTER */}

        <h4>Seat Capacity</h4>

        {uniqueSeats?.map((seat) => (
          <label key={seat}>

            <input
              type="checkbox"
              checked={seatFilter.includes(seat)}
              onChange={() =>
                toggleFilter(
                  seat,
                  seatFilter,
                  setSeatFilter
                )
              }
            />

            {seat} Seater (
            {seatCounts[seat] || 0})

          </label>
        ))}

        {/* MODEL FILTER */}

        <h4>Cab Model</h4>

        {uniqueModels?.map((model) => (
          <label key={model}>

            <input
              type="checkbox"
              checked={modelFilter?.includes(model)}
              onChange={() =>
                toggleFilter(
                  model,
                  modelFilter,
                  setModelFilter
                )
              }
            />

            {model}

          </label>
        ))}

      </div>

      {/* ================= CAR LIST ================= */}

      <div className="carList">

        {loading ? (

          <div
                  style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
                </div>

        ) : filteredCars.length === 0 ? (

          <p>No Cars Found</p>

        ) : (

          filteredCars?.map((car) => (

            <div
              className="carCard"
              key={car.id}
            >

              {/* IMAGE */}

              <img
                loading="lazy"
                src={
                  car?.image ||
                  ""
                }
                alt={car?.name}
                className="carImage"
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />

              {/* DETAILS */}

              <div className="carDetails">

                <h2>{car.name}</h2>

                <div className="tags">
                  <span>{car.type}</span>
                  <span>
                    {car.seats} Seats
                  </span>
                </div>

                <p>
                  8Hrs / 80Kms Package
                </p>

              </div>

              {/* PRICE */}

              <div className="priceSection">

                <h2>
                  {car.price} SAR
                </h2>

                <button
                  className="bookBtn"
                  onClick={() =>
                    handleBookClick(car)
                  }
                >
                  Book Now
                </button>

              </div>

            </div>
          ))
        )}

      </div>
{showPopModal && (
 <div className="success-popup-overlay">
    <div className="success-popup">
      <div className="success-icon">✓</div>

      <h2>Booking Confirmed</h2>

      <p>
        Your  transfer Services has been successfully booked.
      </p>

      <p>
        A confirmation email has been sent to your registered email address.
      </p>

      <div className="booking-id">
        Booking Reference: #{Date.now().toString().slice(-6)}
      </div>

      <div className="redirect-text">
        Redirecting to home page...
      </div>

      <div className="progress-bar">
        <span></span>
      </div>
    </div>
  </div>
)}
      {/* ================= MODAL ================= */}

      {showModal && (
        <div className="modalOverlay">

          <div className="modalContent">

            {/* HEADER */}

            <div className="modalHeader">

              <h2>
                Book{" "}
                {selectedCar?.name}
              </h2>

              <button
                className="closeBtn"
                onClick={() =>
                  setShowModal(false)
                }
              >
                ✕
              </button>

            </div>

            {/* FORM */}

            <form
              onSubmit={handleSubmit}
              className="bookingForm"
            >

              {/* NAME */}

              <label>Name</label>

              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  })
                }
              />

              {/* EMAIL */}

              <label>Email</label>

              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
              />

              {/* MOBILE */}

              <label>Mobile</label>

              <input
                type="tel"
                required
                value={formData.mobile}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    mobile: e.target.value,
                  })
                }
              />

              {/* SUBMIT */}

              <button
                type="submit"
                className="submitBtn"
              disabled={loading}
              >
                 {loading ? "pls wait Booking..." : " Confirm Booking"}
               
           
              </button>

            </form>

          </div>

        </div>
      )}

    </div>
  );
}

export default BookingPage;